import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-md-6 mb-6 mb-md-0" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header mt-5" }
const _hoisted_5 = { class: "d-flex w-100 justify-content-between align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bolder mb-1" }, " Job balance ", -1)
const _hoisted_7 = { class: "card-body p-lg-10" }
const _hoisted_8 = {
  key: 1,
  class: "d-flex flex-column flex-xl-row"
}
const _hoisted_9 = { class: "flex-lg-row-fluid mb-10 mb-xl-0" }
const _hoisted_10 = { class: "mt-n1" }
const _hoisted_11 = { class: "m-0" }
const _hoisted_12 = { class: "flex-grow-1" }
const _hoisted_13 = { class: "d-flex justify-content-end" }
const _hoisted_14 = { class: "mw-300px" }
const _hoisted_15 = { class: "col-12 col-md-6" }
const _hoisted_16 = { class: "card" }
const _hoisted_17 = { class: "card-header mt-5" }
const _hoisted_18 = { class: "d-flex align-items-center justify-content-between w-100" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder mb-1" }, " Estimated projection ", -1)
const _hoisted_20 = { class: "card-body p-lg-10" }
const _hoisted_21 = {
  key: 1,
  class: "d-flex flex-column flex-xl-row"
}
const _hoisted_22 = { class: "flex-lg-row-fluid mb-10 mb-xl-0" }
const _hoisted_23 = { class: "mt-n1" }
const _hoisted_24 = { class: "m-0" }
const _hoisted_25 = { class: "flex-grow-1" }
const _hoisted_26 = { class: "d-flex justify-content-end" }
const _hoisted_27 = { class: "mw-300px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MissingRatesTooltip = _resolveComponent("MissingRatesTooltip")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_JobProjectionTable = _resolveComponent("JobProjectionTable")!
  const _component_JobProjectionTotals = _resolveComponent("JobProjectionTotals")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (_ctx.jobProjection.hasMissingRates)
              ? (_openBlock(), _createBlock(_component_MissingRatesTooltip, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_JobProjectionTable, {
                          "client-invoice": _ctx.formatToDecimal(_ctx.jobProjection.clientInvoice),
                          "worker-salaries": _ctx.formatToDecimal(_ctx.jobProjection.current),
                          "client-currency": _ctx.clientCurrency,
                          "real-client-invoice": _ctx.formatToDecimal(_ctx.jobProjection.realClientInvoice),
                          "is-saving": _ctx.isSaving,
                          "additional-costs": _ctx.additionalCostsState,
                          onAddNewCost: _ctx.handleAddNewCost,
                          onDeleteNewCost: _ctx.handleDeleteNewCost,
                          onSaveCosts: _ctx.handleSaveCosts,
                          onDeleteExistingCost: _ctx.handleDeleteAdditionalCost
                        }, null, 8, ["client-invoice", "worker-salaries", "client-currency", "real-client-invoice", "is-saving", "additional-costs", "onAddNewCost", "onDeleteNewCost", "onSaveCosts", "onDeleteExistingCost"]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_JobProjectionTotals, {
                              "client-currency": _ctx.clientCurrency,
                              total: _ctx.totals ? _ctx.formatToDecimal(_ctx.totals.current) : '0.00'
                            }, null, 8, ["client-currency", "total"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            (_ctx.jobProjection.hasMissingRates)
              ? (_openBlock(), _createBlock(_component_MissingRatesTooltip, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_JobProjectionTable, {
                          "client-invoice": _ctx.formatToDecimal(_ctx.jobProjection.clientInvoice),
                          "worker-salaries": _ctx.formatToDecimal(_ctx.jobProjection.estimated),
                          "client-currency": _ctx.clientCurrency,
                          "is-saving": _ctx.isSaving,
                          "additional-costs": _ctx.additionalCostsState,
                          onAddNewCost: _ctx.handleAddNewCost,
                          onDeleteNewCost: _ctx.handleDeleteNewCost,
                          onSaveCosts: _ctx.handleSaveCosts,
                          onDeleteExistingCost: _ctx.handleDeleteAdditionalCost
                        }, null, 8, ["client-invoice", "worker-salaries", "client-currency", "is-saving", "additional-costs", "onAddNewCost", "onDeleteNewCost", "onSaveCosts", "onDeleteExistingCost"]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_JobProjectionTotals, {
                              "client-currency": _ctx.clientCurrency,
                              total: _ctx.totals ? _ctx.formatToDecimal(_ctx.totals.estimated) : '0.00'
                            }, null, 8, ["client-currency", "total"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
        ])
      ])
    ])
  ]))
}